import { connect } from 'react-redux';
import withProps from 'recompose/withProps';
import BankAccountEdit from '../../main/settings/bankAccount/bankAccountEdit';
import { getBarberBankAccount, updateBarberBankAccount, uploadBankAccountDocuments } from '../../main/settings/actions';
import { barberActiveShop } from '../../auth/selectors';

const mapStateToProps = state => ({
  bankAccount: state.settings.bankAccount,
  shop: state.auth.shop,
  redirectTo: '/barber/settings/bank-account',
  barberUser: state.auth.barberUser,
  currentShop: barberActiveShop(state),
});

const mapDispatchToProps = {
  fetchBankAccount: getBarberBankAccount,
  modifyBankAccount: updateBarberBankAccount,
};

const component = withProps(props => ({
  fetchBankAccount: () => props.fetchBankAccount(props.barberUser.id),
  modifyBankAccount: (id, data) => props.modifyBankAccount(props.barberUser.id, data),
  uploadBankAccountDocuments: documents => uploadBankAccountDocuments(props.barberUser.id, 'barber', documents),
}))(BankAccountEdit);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(component);

